module.exports = __webpack_public_path__ + "resources/img/img_nginx2_m.5d03a72d01248043772ccb23ab3d388e.png";